import { useMutation } from '@tanstack/react-query'

import { generateCustomVariants } from '../api'

const useGenerateCustomVariantsMutation = () => {
  return useMutation({ mutationFn: generateCustomVariants })
}

export default useGenerateCustomVariantsMutation
